(function() {
    'use strict';

        angular.module( APP_ID )
            .component( 'requirements', {
                bindings: {
                    content: '<'
                },
                templateUrl: 'app/views/partials/content/requirements.html',
                controller:   RequirementsController,
                controllerAs: 'vm',

                renderingOptions: {
                    'requirements': {
                        inputs:    [ 'content="::content.asset_contents"' ],
                        classes: [
                            'block-container',
                            'requirements'
                        ],
                        wrapStart: '<div class="centraliser">',
                        wrapEnd:   '</div>'
                    }
                },

                renderingOptionsOverrides: {
                    nested: {
                        'requirements': {
                            wrapStart:     null,
                            wrapEnd:       null,
                            classes:       null,
                            parentClasses: [
                                'block-container',
                                'requirements'
                            ]
                        }
                    }
                }
            });


        /**
         * Lists out all requirements in a nested structure.
         *
         * @param {ng.IScope} $scope
         * @param {DataService} DataService
         * @param {LoggerFactory} LoggerFactory
         * @param {Utils} Utils
         * @param {Object} TEXTS
         * @param {Object} CONFIG
         */
        function RequirementsController(
            $scope,
            DataService,
            LoggerFactory,
            Utils,
            TEXTS,
            CONFIG
        ){

            /** @type {angular.IController} */
            var vm = this;





            /* ===== PRIVATE MEMBERS ============================================ */


            /** @type {Logger} */
            var logger = LoggerFactory.createLogger( 'RequirementsController' );


            /** @type {Promise<Object>} */
            var coursesPromise;


            /** @constant */
            var REQUIREMENT_TYPE = {
                COURSE:         'course',
                MARKUP:         'markup',
                PLAIN:          'plain'
            },


            // Matches 'ABCD 111' or 'ABCD 111-999' (+ 4 different dashes)
            COURSE_CODE_REGEXP          = /[A-Z]{4}\s?\d{3}([‒–—―-]\d{3})?/g,

            // Matches URLs that end with course URL format .../accy/109/2019 (with
            // optional trailing slash). The start of the path up to the year
            // portion of the URL is added as a Regexp Group, allowing easy removal of the year
            // portion.
            COURSE_URL_YEAR_REPLACE_REGEXP = /(.*\/[a-z]{4}\/[0-9]{3})\/[0-9]{4}\/?$/g;





            /* ===== EXPOSE TO THE SCOPE ======================================== */


            $scope._    = TEXTS.GENERIC.REQUIREMENTS;
            $scope.TYPE = REQUIREMENT_TYPE;





            /* ===== RUN ON INSTANTIATION ======================================= */


            /** @constructor */
            vm.$onInit = function() {
                vm.contentPlain = {
                    heading: vm.content.heading,
                    content: vm.content.intro
                };

                initRequirementsList();
            };


            /** *MUST BE* present to allow directive `collapsible` to bind to the Controller's $postLink event. */
            Utils.addGenericPostLinkTrigger( vm );





            /* ===== PRIVATE FUNCTIONS ========================================== */


            function initRequirementsList() {
                vm.requirements = buildNestedRequirementsRecursively( vm.content.asset_contents );
            }


            /**
             * Recursively creates clean nested JSON structure of requirements.
             *
             * @param {Array<Object>} requirementsList List of requirements
             *                                         retrieved from the API.
             *
             * @returns {null|Object} List of well-formed requirement objects.
             */
            function buildNestedRequirementsRecursively( requirementsList ) {
                if ( !( requirementsList && requirementsList.length > 0 ) ) {
                    // No requirements OR empty list -> Return nothing
                    return null;
                }

                return requirementsList.map( function( requirement ) {
                    var requirementObject = {};

                    //TODO: Remove after it's cleaned up from the Squiz API
                    if ( !requirement.hasOwnProperty( 'content' ) && !requirement.hasOwnProperty( 'contentMarkup' ) && requirement.hasOwnProperty( 'heading' ) ){
                        logger.warn( "This requirement is missing attributes `content` or `contentMarkup` and needs to be updated to newer structure!", requirement );
                        requirement.contentMarkup = requirement.heading;
                    }

                    if ( requirement.hasOwnProperty( 'content' ) ) {
                        var courseIdsList = requirement.content.match( COURSE_CODE_REGEXP );

                        if ( courseIdsList ){
                            requirementObject.type = REQUIREMENT_TYPE.COURSE;
                            injectMixedContentToRequirement( requirement.content, courseIdsList, requirementObject );
                        } else {
                            requirementObject.type      = REQUIREMENT_TYPE.PLAIN;
                            requirementObject.content   = requirement.content;
                        }
                    } else if ( requirement.hasOwnProperty( 'contentMarkup' ) ) {
                        requirementObject.type      = REQUIREMENT_TYPE.MARKUP;
                        requirementObject.content   = requirement.contentMarkup;
                    } else {
                        logger.error( "Could not determine how to process given requirement, leaving it empty. Please, double check that either `content` or `contentMarkup` are in place.", requirement );
                    }

                    // Recursively add sub-requirements, if any
                    var subrequirementsList = buildNestedRequirementsRecursively( requirement.asset_children );

                    if ( subrequirementsList ) requirementObject.subrequirements = subrequirementsList;

                    return requirementObject;
                });
            }

            /**
             * Lazy loads a list of all courses and replaces all course IDs found
             * in the original plain content `contentMarkup` with HTML links to
             * the given course or course range.
             *
             * @param {string} contentMarkup Original, unformatted plain content.
             * @param {Array<string>} courseIdsList List of course codes and course
             *                                      ranges.
             * @param {Object} requirementObject Requirement to attach the
             *                                  `content` to.
             */
            function injectMixedContentToRequirement( contentMarkup, courseIdsList, requirementObject ){
                if ( !coursesPromise ) {
                    // Lazy-loaded API call
                    coursesPromise = DataService.getCourses();
                }

                coursesPromise.then( function( coursesObject ) {
                    // Replace the original IDs with links to courses
                    courseIdsList.forEach( function( courseId ){
                        // 1) Normalise
                        var normalisedCourseId = courseId.replace( ' ', '' );

                        // 2) Determine type & replace with enhanced version
                        if ( normalisedCourseId.length === 7 ){
                            // Course
                            if ( coursesObject.hasOwnProperty( normalisedCourseId ) ){
                                contentMarkup = contentMarkup.replace( courseId, getCourseLinkMarkup( courseId, coursesObject[ normalisedCourseId ] ) );
                            } else {
                                logger.warn( "Course with code `%s` does not exist in the list of all courses! Leaving as a plain text.", normalisedCourseId );
                            }
                        } else if ( normalisedCourseId.length === 11 ){
                            // Course range
                            contentMarkup = contentMarkup.replace( courseId, getCourseRangeLinkMarkup( courseId ) );
                        } else {
                            logger.warn( "Unknown format for a course (format: XXX 9999) or a course range (format: XXX 111-999). Cannot create a link for %s, leaving unchanged...", normalisedCourseId );
                        }

                        // 3) Attach content to the requirement
                        requirementObject.content = contentMarkup;
                    });

                }).catch( function( errorObject ) {
                    logger.error( "Cannot get list of all courses from the API. Won't be able to render any course-specific information (URLs, titles) for following course IDs: ", courseIdsList, errorObject );

                    // 3) Attach content to the requirement
                    requirementObject.content = contentMarkup;
                });
            }

            /**
             * Constructs <a> to link to the course.
             *
             * @param {string} courseId Subject code + course code.
             * @param {Object} course Object with course information.
             *
             * @returns {string} HTML markup of the correct <a> link.
             */
            function getCourseLinkMarkup( courseId, course ){
                return '<a href="' + course.url.replace(COURSE_URL_YEAR_REPLACE_REGEXP, '$1') + '" target="_blank" title="' + $scope._.COURSE_LINK_TITLE_PREFIX + ' ' + course.name + '">' + course.name + ' ' + '(' + courseId + ')' + '</a>';
            }

            /**
             * Constructs <a> to link to the SERP with courses in given course
             * range.
             *
             * @param {string} courseRangeId Subject code + starting course code
             *                               + ending course code.
             *
             * @returns HTML markup of the correct <a> link.
             */
            function getCourseRangeLinkMarkup( courseRangeId ){
                // Break the `courseRangeId` down to separate pieces and create valid search URL
                var url = courseRangeId.replace( /([A-Z]{4})\s?(\d{3})[‒–—―-](\d{3})?/, function( _, subjectCode, courseRangeStart, courseRangeEnd ) {
                    // return CONFIG.API.WEB_SEARCH.BASE_URL + '?q=+&as_q=inmeta:subjectcode=' + subjectCode + '+AND+inmeta:coursenumber:' + courseRangeStart + '..' + courseRangeEnd + '&site=course_search_collection';

                    return CONFIG.API.WEB_SEARCH.BASE_URL + '?q=' + subjectCode + '&ge_courseNumber=' + courseRangeStart + '&le_courseNumber=' + courseRangeEnd + '&tab=courses';
                });


                return '<a href="' + url + '" target="_blank" title="' + $scope._.COURSE_RANGE_LINK_TITLE_PREFIX + ' ' + courseRangeId + '">' + courseRangeId + '</a>';
            }


        }



        RequirementsController.$inject = [ '$scope', 'DataService', 'LoggerFactory', 'Utils', 'TEXTS', 'CONFIG' ];
    })();
